import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Field from 'component/utils/Field'

import Modal from 'component/utils/Modal'
import CustomInputFile, { SCREEN_TYPES } from 'component/utils/CustomInputFile'

import Col from 'component/utils/Col'

const FIELDS = ['logo']

export const MODAL_TYPE = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
}

const LogoBrandsModal = ({
  translate,
  modalType,
  currentItem,
  changeModal,
  handleSave,
  handleDelete,
  fields,
  values,
  setValueToField,
  oldImage,
  handleUpdate,
}) => {
  const renderContent = () => {
    switch (modalType) {
      case MODAL_TYPE.VIEW:
        return (
          <section className='modal-container modal-container-view'>
            <Col xs={12}>
              <span>
                <strong>{translate('provider')}:</strong> {currentItem.nmBrand}
              </span>
            </Col>

            <Col mdOffset={4} xs={12} md={4}>
              <img
                src={currentItem.dsLinkLogo}
                alt={currentItem.nmBrand}
                className='image'
              />
            </Col>

            <Col mdOffset={2} xs={12} md={4}>
              <button
                onClick={() => changeModal(MODAL_TYPE.EDIT, currentItem)}
                className='button-hollow button-hollow-primary button-full'
              >
                {translate('edit_button_label')}
              </button>
            </Col>

            <Col xs={12} md={4}>
              <button
                onClick={() => changeModal()}
                className='button button-primary button-full'
              >
                {translate('ok_button')}
              </button>
            </Col>
          </section>
        )
      case MODAL_TYPE.EDIT:
        return (
          <section className='modal-container modal-container-edit'>
            <span>
              <strong>{translate('provider')}:</strong> {currentItem.nmBrand}
            </span>

            <form onSubmit={beforeHandleSave}>
              <Col mdOffset={4} xs={12} md={4}>
                <Field {...fields.logo}>
                  <CustomInputFile
                    name='logo'
                    filePreview={
                      values.logo || {
                        name: currentItem.nmBrand,
                        fileToPreview: currentItem.dsLinkLogo,
                      }
                    }
                    handleFileChange={handleFileChange}
                    screen={SCREEN_TYPES.EDIT}
                    showName={!!values.logo}
                    translate={translate}
                  />
                </Field>
              </Col>

              {values.logo && (
                <Col mdOffset={4} xs={12} md={4}>
                  <button className='button button-primary button-full'>
                    {translate('send')}
                  </button>
                </Col>
              )}
            </form>
          </section>
        )
      case MODAL_TYPE.DELETE:
        return (
          <section className='modal-container'>
            <span>
              {translate('datasheetManagement.logoBrands.delete.message')}
            </span>

            <Col mdOffset={2} xs={12} md={4} className='margin-top-double'>
              <button
                onClick={() => handleDelete()}
                className='button button-danger button-full'
              >
                {translate('exclude_button')}
              </button>
            </Col>

            <Col xs={12} md={4} className='margin-top-double'>
              <button
                onClick={() => changeModal()}
                className='button-hollow button-hollow-primary button-full'
              >
                {translate('cancel_button')}
              </button>
            </Col>
          </section>
        )
      case MODAL_TYPE.UPDATE:
        return (
          <section className='modal-container modal-container-update'>
            <span>
              {translate('datasheetManagement.logoBrands.modal.update')}
            </span>

            <Col mdOffset={4} xs={12} md={4}>
              <img
                src={oldImage.dsLinkLogo}
                alt={oldImage.nmBrand}
                className='image'
              />
            </Col>

            <Col mdOffset={2} xs={12} md={4}>
              <button
                onClick={() => changeModal()}
                className='button-hollow button-hollow-danger button-full align-center'
              >
                {translate('cancel_button_label')}
              </button>
            </Col>

            <Col xs={12} md={4}>
              <button
                onClick={() => handleUpdate()}
                className='button button-primary button-full'
              >
                {translate('ok_button')}
              </button>
            </Col>
          </section>
        )
      default:
        return <Fragment />
    }
  }

  const beforeHandleSave = (event) => {
    event.preventDefault()

    const valuesToSave = { nmBrand: { value: currentItem.nmBrand }, ...values }

    handleSave(valuesToSave, changeModal)
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0]

    const fileToPreview = await new Promise((resolve) => {
      const reader = new FileReader()

      reader.onloadend = ({ target: { result } }) => resolve(result)

      reader.readAsDataURL(file)
    })

    setValueToField('logo', {
      fileToPreview,
      fileToUpload: file,
      name: file.name,
    })
  }

  return <Modal closeModal={() => changeModal()}>{renderContent()}</Modal>
}

LogoBrandsModal.propTypes = {
  modalType: PropTypes.string.isRequired,
  currentItem: PropTypes.object.isRequired,
  changeModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  oldImage: PropTypes.object,
}

export default Form({ fields: FIELDS })(LogoBrandsModal)

export { LogoBrandsModal }
